import axiosInstance from "../axiosInstance";

export const customerService = {
  create: async (data) => {
    try {
      const response = await axiosInstance.post("/customer", data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  fetch: async (searchValue, client_id, buildQuery) => {
    try {
      let api_query = `/customer?$sort[createdAt]=-1`;
      if (client_id) api_query += `&clients=${client_id}`;
      if (searchValue) api_query += `&name[$search]=${searchValue}`;
      if (buildQuery) api_query += `&${buildQuery}`;
      const response = await axiosInstance.get(api_query);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  edit: async (id, data) => {
    try {
      const response = await axiosInstance.patch(`/customer/${id}`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  delete: async (id) => {
    try {
      const response = await axiosInstance.delete(`/customer/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  fetchUniqueField: async (
    field,
    searchKey,
    client_id,
    limit = 15,
    skip = 0,
  ) => {
    try {
      let query = `/customer?$limit=${limit}&$skip=${skip}&$select[]=${field}`;
      if (client_id) query += `&clients=${client_id}`;
      if (searchKey) query += `&${field}[$search]=${searchKey}`;
      const response = await axiosInstance.get(query);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
